import React from 'react';
import parse from 'html-react-parser';

function About(props) {
    const { data } = props;

    return (
        <div className="about-wrapper">
            <h4 className="section-header">A propos</h4>

            <div className="card">
                <div className="about-txt">
                    {parse(data.User.about)}
                </div>
            </div>
        </div>
    );
}
export default About;